import { JSONLD } from 'lincd-jsonld/utils/JSONLD';
import { createNameSpace } from 'lincd/utils/NameSpace';
import { linkedOntology } from '../package.js';
import * as _this from './xsd.js';
export var loadData = () => {
    if (typeof module !== 'undefined' && typeof exports !== 'undefined') {
        // CommonJS import
        return import('../data/xsd.json').then((data) => JSONLD.parse(data));
    }
    else {
        // ESM import
        //@ts-ignore
        return import('../data/xsd.json', { with: { type: 'json' } }).then((data) => JSONLD.parse(data.default));
    }
};
export var ns = createNameSpace('http://www.w3.org/2001/XMLSchema#');
export var _self = ns('');
export var Bytes = ns('Bytes');
export var string = ns('string');
export var boolean = ns('boolean');
export var date = ns('date');
export var long = ns('long');
export var integer = ns('integer');
export var time = ns('time');
export var duration = ns('duration');
export var decimal = ns('decimal');
export var gYear = ns('gYear');
export var dateTime = ns('dateTime');
export var anyURI = ns('anyURI');
//not yet required by core so why define it?
//export var boolean:NamedNode = resources.getOrCreate(base+"boolean");
export const xsd = {
    Bytes,
    string,
    boolean,
    date,
    long,
    integer,
    time,
    duration,
    decimal,
    gYear,
    dateTime,
    anyURI,
};
linkedOntology(_this, ns, 'xsd', loadData, '../data/xsd.json');
//# sourceMappingURL=xsd.js.map